module.exports = __webpack_public_path__ + "images/emoji/kissing_closed_eyes.70802de0942507cb98be.png";